import React, { useEffect, useState } from 'react';
import { TransactionsVService, PaymentTransactionTypeEnum } from '../../services/V2/gozer';
import { Grid } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CCImage from '../Wallet/CC/CCImage';
import GetAppIcon from '@mui/icons-material/GetApp';
import { withToast } from '../Shared/Toast';
import { getTransactionHistory } from '../Shared/ExportsFunctions';
import { CustomTable } from '../Shared/CustomTable';
import { formatMoney } from '../Shared/Functions';
import { IsMobile } from '../Shared/Functions';
import { PaymentTypes } from '../../services/PaymentTypes';
import { PaymentMethodTypes } from '../../services/PaymentMethodTypes';

const TransactionHistory = ({ account }) => {
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true)
    }, [account])// eslint-disable-line react-hooks/exhaustive-deps

    const handleDownload = async () => {
        var date = new Date();
        await getTransactionHistory(account.id, {
                pageNumber: 1,
                orderBy: "CreatedAt",
                orderByDesc: true,
                filters: [{
                    property: "BillingAccountId",
                    value: account.id
                },
                {
                    property: "Error",
                    value: null
                }],
                fromDate: new Date((date).setFullYear(date.getFullYear()-2)).toUTCString()
            })
    }

    const checkNegative = (transactionType, value) => {
		let amount = 0;
		amount = (transactionType !== PaymentTransactionTypeEnum.CHARGE && value > 0) ? value * -1 : value;
		return amount
    }

    return (
        <Grid container>
            <Grid xs={12} style={{ padding: "0px 25px" }}>
                <CustomTable
                    title={"TRANSACTION HISTORY"}
                    refresh={loading}
                    setRefresh={setLoading}
                    columns={[
                        {
                            field: "createdAt",
                            title: "Date",
                            editable: 'never',
                            render: params => new Date(params.createdAt ?? 0).toLocaleDateString(),
                            sorting: false
                        },
                        {
                            field: "paymentTransactionType",
                            title: "Type",
                            editable: 'never',
                            render: params => PaymentTypes.find(x => x.paymentTransactionType === params.paymentTransactionType)?.name,
                            sorting: false
                        },
                        {
                            field: "paymentType",
                            title: "Method",
                            editable: 'never',
                            render: params => (params.paymentType === "CC" && params.token) ?
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <div style={{ marginRight: "5px" }}>
                                    <CCImage className="cc-vendor-image-sm" token={params.token}/>
                                </div>
                                <div style={{ marginLeft: "5px" }}>
                                    {params.token?.last4 && "****"}{params.token?.last4}
                                </div>
                            </div>
                            : (params.paymentType === "ACH" && params.token) ?
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <div style={{ marginRight: "5px" }}>
                                    <AccountBalanceIcon />
                                </div>
                                <div style={{ marginLeft: "5px" }}>
                                    {params.token?.last4 && "****"}{params.token?.last4}
                                </div>
                            </div>
                            :
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <div>
                                    {PaymentMethodTypes.find(x => x.paymentMethodType === params.paymentType)?.name}
                                </div>
                            </div>,
                            sorting: false
                        },
                        {
                            field: "amount",
                            title: "Payment Amount",
                            editable: 'never',
                            render: (params:any) => formatMoney(checkNegative(params.paymentTransactionType, params.amount)),
                            hidden: IsMobile(),
                            sorting: false
                        },
                        {
                            field: "serviceFeeAmount",
                            title: "Service Fee Amount",
                            editable: 'never',
                            render: (params:any) => formatMoney(checkNegative(params.paymentTransactionType, params.serviceFeeAmount)),
                            hidden: IsMobile(),
                            sorting: false
                        },
                        {
                            field: "total",
                            title: "Total",
                            editable: 'never',
                            render: (params:any) => formatMoney(checkNegative(params.paymentTransactionType, params.serviceFeeAmount) + checkNegative(params.paymentTransactionType, params.amount)),
                            sorting: false
                        },
                        {
                            field: "confirmationNumber",
                            title: "Confirmation Number",
                            editable: 'never',
                            sorting: false
                        }
                    ]}
                    dataEndpoint={async query => {
                        var date = new Date();
                        let data = await TransactionsVService.transactionsVGetAll(account.id, {
                            pageNumber: query.page,
                            numberPerPage: 10,
                            orderBy: query?.orderBy?.field?.toString() ?? "CreatedAt",
                            orderByDesc: true,
                            filters: [{
                                property: "BillingAccountId",
                                value: account.id
                            },
                            {
                                property: "Error",
                                value: null
                            }],
                            fromDate: new Date((date).setFullYear(date.getFullYear()-2)).toUTCString()
                        })
                        setLoading(false)
                        return {
                            data: data.items ?? [],
                            totalCount: data.numberOfItems ?? 0,
                            numberPerPage: 10
                        }
                    }}
                    actions={[
                        {
                            icon: () => <GetAppIcon />,
                            tooltip: "Export",
                            isFreeAction: false,
                            onClick: () => handleDownload()
                        }
                    ]}
                    pageSize={10}
                    onRowClick={null}
                />
            </Grid>
        </Grid>
    )
}
export default withToast(TransactionHistory);